/* ACTION TYPES */
export enum VIDEO_DATA_ACTIONS {
    /* video-level actions */
    SET_VIDEO_DATA = 'SET_VIDEO_DATA',
}
